"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _attributeIds = _interopRequireDefault(require("@devsontap/nica-api/core/utils/attributeIds"));

var _selectors = require("../../../../redux/attributes/selectors");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Specialties = function Specialties(_ref) {
  var location = _ref.location;
  var icon = (0, _selectors.useAttributeIconSelector)(_attributeIds.default.practiceSpecialty);
  var attributeMap = (0, _selectors.useAttributeMapSelector)();
  var specialties = [];
  var locationSpecialties = location && location.attributes ? location.attributes[_attributeIds.default.practiceSpecialty] : null;

  if (locationSpecialties) {
    specialties = locationSpecialties.choice.map(function (specialtyId) {
      return attributeMap && attributeMap[_attributeIds.default.practiceSpecialty] ? attributeMap[_attributeIds.default.practiceSpecialty].options[specialtyId].name : "";
    });
  }

  specialties.sort(function (l1, l2) {
    return l1.localeCompare(l2);
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "medications-available-container flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "details-section-icon-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: icon,
    className: "details-section-icon",
    alt: "specialties"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "details-section-header headlineFont specialties-header"
  }, "Practice Specialty"), /*#__PURE__*/_react.default.createElement("div", null, specialties.length ? specialties.map(function (specialty, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "specialty-".concat(index),
      className: "specialty bodyFont"
    }, specialty);
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "specialties-empty bodyFont"
  }, "This information is not available yet."))));
};

var _default = Specialties;
exports.default = _default;